import toastr from "toastr";
// 初期実行
$(document).ready(function () {
    if ($(".js-account-page").length === 0) {
        return;
    }

    $(".js-content").show();

    // トースト表示
    const messageObject = $(".flashMessage");
    if (messageObject.length !== 0) {
        const messageString = $(messageObject).data("flash_message");

        if (messageString !== "") {
            toastr.options = {
                closeButton: false,
                debug: false,
                newestOnTop: false,
                progressBar: false,
                positionClass: "toast-bottom-full-width",
                preventDuplicates: false,
                onclick: null,
                showDuration: "300",
                hideDuration: "1000",
                timeOut: "5000",
                extendedTimeOut: "1000",
                showEasing: "swing",
                hideEasing: "linear",
                showMethod: "fadeIn",
                hideMethod: "fadeOut"
            };
            toastr.success(messageString);
        }
    }
});
